import { useNavigate } from "react-router-dom"
import React from 'react';
import { useAuth } from "../../hooks/useAuth";

const Unauthorized : React.FC = () => {
    const { user } = useAuth();

    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>Não autorizado</h1>
            <br />
            <p>{user.name}, você não possui acesso a esta página.</p>
            <div className="flexGrow">
                <button onClick={goBack}>Voltar</button>
            </div>
        </section>
    )
}

export default Unauthorized